import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	CheckFinancialStatementResponse,
	FinancialStatementCheckPayload,
	FinancialStatementListResponse,
	FinancialStatementRequest,
	SendOtpResponse,
} from '../models/financialStatement';

export const onGetFinancialStatementList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<FinancialStatementListResponse>>('dashboard/actions/financial-statement', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetFinancialStatementById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<FinancialStatementRequest>>(`dashboard/actions/financial-statement/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckFinancialStatementExists = async (data: FinancialStatementCheckPayload) => {
	try {
		const response = await axios.post<JsonResponse<CheckFinancialStatementResponse>>(
			`dashboard/actions/financial-statement/check-exists`,
			data,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendFinancialStatementOtp = async () => {
	try {
		const response = await axios.post<JsonResponse<SendOtpResponse>>(`dashboard/actions/financial-statement/send-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSubmitFinancialStatement = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<SendOtpResponse>>(`dashboard/actions/financial-statement`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
